import { Component, computed, input, OnChanges, Signal } from '@angular/core';
import { AggregateResponse } from '@r1-compass-library/models/reporting/aggregate-response.model';
import { ChartSeries } from '@r1-compass-library/models/reporting/chart-data.model';
import { Color, NgxChartsModule } from '@swimlane/ngx-charts';

@Component({
    selector: 'r1-compass-app-sum-bar-chart',
    imports: [NgxChartsModule],
    templateUrl: './sum-bar-chart.component.html',
})
export class SumBarChartComponent implements OnChanges {
    view = '';
    showXAxis = true;
    showXAxisLabel = true;
    xAxisLabel = 'Total';
    showYAxis = true;
    showYAxisLabel = true;
    yAxisLabel = 'Play ID';
    gradient = false;
    showLegend = false;
    showDataLabel = true;
    results: ChartSeries[] = [];

    colorScheme = {
        domain: ['#1174b6'],
    } as Color;

    chartData = input.required<AggregateResponse[]>();

    graphHeight: Signal<number | 'calc(100% - 75px)'> = computed(() => {
        const resultHeight: number = this.results.length * 30;
        return resultHeight < 700 ? 'calc(100% - 75px)' : resultHeight;
    });

    ngOnChanges() {
        this.results = this.transformChartData(this.chartData());
    }

    private transformChartData(chartData: AggregateResponse[]): ChartSeries[] {
        const results: ChartSeries[] = [];
        chartData.forEach(data => {
            results.push({
                name: data.key,
                value: data.aggregate,
            } as ChartSeries);
        });
        return results;
    }
}
